import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';

// Components
// @ts-ignore
import { ADMIN } from 'components/RoleGate/constants';
import WorkTypeForm from './components/WorkTypeForm';

interface ConnectedProps {
    open: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class CreateWorkTypeModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            createWorkTypeModal: undefined
        });
    };

    render(): React.ReactElement {
        const { open } = this.props;
        return (
            <RoleGate requiredRoles={[ADMIN]}>
                <Modal
                    open={open}
                    onClose={this.handleClose}
                    size="fullscreen"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="CreateWorkTypeModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Create Task</Modal.Header>
                        <Modal.Content className="constrain-width">
                            <WorkTypeForm onClose={this.handleClose} />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    open: makeSelectQueryStringBooleanValue('createWorkTypeModal')
});

export default connect(mapStateToProps, { updateQueryString })(
    CreateWorkTypeModal
);
